<div class="header-bar">
  <h1>Engineius Organisations Report</h1>
</div>
<div class="">
  <div class="content-container">
    <div class="">
      <div class="">
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel">
            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.createDateFrom.value"
                  name="createDateFrom"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Date Create From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.createDateTo.value"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Date Create To</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div class="ui-g-3">
                <label>Type</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="organisationTypes"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="filterVal.filters.organisationType.value"
                  name="organisationTypes"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <input
                  pInputText
                  name="town"
                  type="text"
                  style="width: 100%"
                  [(ngModel)]="filterVal.filters.town.value"
                />
                <label>Town</label>
              </span>
            </div>

            <div class="ui-g-12">
              <button
                pButton
                type="button"
                label="Clear"
                class="ui-button btn-to-right"
                (click)="clearFilter(dt)"
              ></button>
              <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
            </div>
          </div>
        </form>

        <p-table
          #dt
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [hidden]="!isLoaded"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
        >
          <ng-template pTemplate="header">
            <tr class="no-wrap-cells cells-overflow-hidden">
              <th style="width: 130px" pResizableColumn pSortableColumn="name">
                Organisation Name
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="addressDetails">
                Address Details
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="organisationType">
                Organisation Type
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="dateCreated">
                Date Created
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="tagsCount">Tags</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="costCentresCount">
                Cost Centres
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="jobsLastWeek">
                Jobs/Orders in past month
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="jobsLastMonth">
                Jobs/Orders in past year
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="usersCount">
                User Count by Organisation
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="driversCount">
                Driver count by Suppliers
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="regionsCount">
                Regions Count
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="depositCount">
                Depots Count
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="activeUsers">
                Active User
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="rating">Rating</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="postcodeAreas">
                Supplier Postcode Areas Active In
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="no-wrap-cells cells-overflow-hidden">
              <td>{{ item.name }}</td>
              <td>{{ item.addressDetails }}</td>
              <td>{{ item.organisationType }}</td>
              <td>
                <span>{{ item.dateCreated | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>{{ item.tagsCount }}</td>
              <td>{{ item.costCentresCount }}</td>
              <td>
                <span>{{ item.jobsLastWeek }} / {{ item.ordersLastWeek }}</span>
              </td>
              <td>
                <span>{{ item.jobsLastMonth }} / {{ item.ordersLastMonth }}</span>
              </td>
              <td>{{ item.usersCount }}</td>
              <td>{{ item.driversCount }}</td>
              <td>{{ item.regionsCount }}</td>
              <td>{{ item.depostCount }}</td>
              <td>
                <span>{{ item.activeUsers | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>{{ item.rating }}</td>
              <td>{{ item.postcodeAreas }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLES DEPRECATED ---

        <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                     [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                     [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3">
            <p-column field="name" header="Organisation Name" [sortable]="tru"></p-column>
            <p-column field="addressDetails" header="Address Details" [sortable]="tru">
            </p-column>
            <p-column field="organisationType" header="Organisation Type" [sortable]="tru"></p-column>
            <p-column field="dateCreated" header="Date Created" [sortable]="tru">
                <ng-template let-col let-order="rowData" pTemplate="body">
                    <span>{{ order[col.field] | date:'dd/MM/yyyy' }}</span>
                </ng-template>
            </p-column>

            <p-column field="tagsCount" header="Tags" [sortable]="tru"></p-column>
            <p-column field="costCentresCount" header="Cost Centres" [sortable]="tru"></p-column>
            <p-column field="" header="Jobs/Orders in past week" [sortable]="false">
                <ng-template let-col let-org="rowData" pTemplate="body">
                    <span>{{ org.jobsLastWeek }} / {{ org.ordersLastWeek }}</span>
                </ng-template>
            </p-column>
            <p-column field="" header="Jobs/Orders in past month" [sortable]="false">
                <ng-template let-col let-org="rowData" pTemplate="body">
                    <span>{{ org.jobsLastMonth }} / {{ org.ordersLastMonth }}</span>
                </ng-template>
            </p-column>
            <p-column field="" header="Jobs/Orders in past year" [sortable]="false">
                <ng-template let-col let-org="rowData" pTemplate="body">
                    <span>{{ org.jobsLastYear }} / {{ org.ordersLastYear }}</span>
                </ng-template>
            </p-column>
            <p-column field="usersCount" header="User count by Organisation" [sortable]="tru"></p-column>
            <p-column field="driversCount" header="Drivers count by Suppliers" [sortable]="tru"></p-column>
            <p-column field="regionsCount" header="Regions count" [sortable]="tru"></p-column>
            <p-column field="depotsCount" header="Depots count" [sortable]="tru"></p-column>

            <p-column field="activeUsers" header="Active User" [sortable]="false">
                <ng-template let-col let-order="rowData" pTemplate="body">
                    <span>{{ order[col.field] | date:'dd/MM/yyyy' }}</span>
                </ng-template>
            </p-column>
            <p-column field="rating" header="Rating" [sortable]="false"></p-column>
            <p-column field="postcodeAreas" header="Supplier postcode areas active in" [sortable]="false"></p-column>
        </p-dataTable>

        --->
      </div>
      <div class="ui-g-12" style="height: 40px; margin-top: 20px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-file-download"
          label="Download"
          class="ui-button btn-to-right"
          (click)="downloadReport()"
          [disabled]="page.total == 0"
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
